import React, { Fragment, useState, useEffect } from "react";
import InspectionItem from "../../models/InspectionItem";
import ToggleSwitch from "../../components/ToggleSwitch";

const FormPartial = (props) => {
  const { x, setVehicleInspectionItems } = props;
  const [inspectionItem , setInspectionItem ] = useState(props.inspectionItem) 
  const item = props.inspectionItem
  let inspectionItemObj = new InspectionItem(inspectionItem);

  useEffect(()=>{
    setVehicleInspectionItems((prevState)=>{
      let prevInspectionItems = prevState.inspection_items
      prevInspectionItems[inspectionItem.index] = inspectionItem
      return {...prevState, inspection_items: prevInspectionItems}
    })
  }, [inspectionItem])

  const handleChangeDynamicFields = (e) =>{
    setInspectionItem((prevState)=>{
      let updatedInspecitonItem;
      if(e.target.value === "on" || e.target.checked === "off") {
        updatedInspecitonItem = new InspectionItem({...prevState, [e.target.name]: e.target.checked});
      } else {
        updatedInspecitonItem = new InspectionItem({...prevState, [e.target.name]: e.target.value});
      }
      try {
        updatedInspecitonItem.completeValidation();
      } catch (e) {
        // e.preventDefault();
      }
      return updatedInspecitonItem;
    })
  }

  return <Fragment>
        <div className="d-flex">
          <div className="col m-2">
            <label htmlFor='name' className="form-label mb-1">Name</label>
            <input
              id="name"
              name="name"
              value={inspectionItem?.name}
              onChange={(e) => handleChangeDynamicFields(e)}
              type="text"
              className="form-control form-control-sm font-size-12"
              aria-describedby="nameHelp"
              placeholder='Enter Name'
              disabled={true}
            />
            <div id="nameHelp" className="form-text text-danger mt-0">
              {inspectionItem.errors.name}
            </div>
          </div>
          <div className="col m-2">
            <label htmlFor='amount' className="form-label mb-1">Amount</label>
            <input
              id="amount"
              name="amount"
              value={inspectionItem?.amount}
              onChange={(e) => handleChangeDynamicFields(e)}
              type="number"
              className="form-control form-control-sm font-size-12"
              aria-describedby="amountHelp"
              placeholder='Enter amount'
            />
            <div id="amountHelp" className="form-text text-danger mt-0">
              {inspectionItem.errors.amount}
            </div>
          </div>
          <div className="col m-2">
            <label htmlFor='chargable' className="form-label mb-1">Chargeable</label><br/>
            <div className="toggle-switch">
              <input
                id="chargable"
                type="checkbox"
                name="chargable"
                onChange={(e) => handleChangeDynamicFields(e)}
                checked={inspectionItem?.chargable}
              />
            </div>
          </div>
          <div className="col m-2">
            <label htmlFor='is_active' className="form-label mb-1">Active</label><br/>
            <div className="toggle-switch">
              <input
                id="is_active"
                type="checkbox"
                name="is_active"
                onChange={(e) => handleChangeDynamicFields(e)}
                checked={inspectionItem?.is_active}
              />
            </div>
          </div>
          <div className="col m-2">
            <label htmlFor='gst' className="form-label mb-1">GST</label>
            <input
              id="gst"
              name="gst"
              value={inspectionItem?.gst}
              onChange={(e) => handleChangeDynamicFields(e)}
              type="number"
              step="0.1"
              className="form-control form-control-sm font-size-12"
              aria-describedby="gstHelp"
              placeholder='Enter gst amount'
            />
            <div id="gstHelp" className="form-text text-danger mt-0">
              {inspectionItem.errors.gst}
            </div>
          </div>
        </div>
  </Fragment>
}

export default FormPartial;
